import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const Total = (props) => {
  const { cartOrOrder, type } = props;
  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);

  const { currency } = settings;
  const { totalAfterTip, purchaseType } = cartOrOrder;

  let label = t('checkout.general.total');
  if (purchaseType === 'Refund') {
    label = t('checkout.general.refundTotal');
  }

  return (
    <>
      <div className="c7-order-summary__item--total">
        <div className="c7-order-summary__title">
          {type === 'Estimate' && t('checkout.general.estimated')} {label}
        </div>
        <div className="c7-order-summary__value">
          <span>{currency}</span>
          {currencyFormat(totalAfterTip, currency)}
        </div>
      </div>
    </>
  );
};

export default Total;
